import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

class AdminOrganizationEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "AdminOrganization";
        this.primaryEnterpriseComponent = "AdminOrganization";

        let eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "AdminOrganization";
        eom.enterpriseComponent = "AdminOrganization";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "AdminOrganizationPosition";
        eom.enterpriseComponent = "AdminOrganizationPosition";
        eom.relationship = "AdminOrganizationAdminOrganizationPosition";
        this.enterpriseComponentMembers.set(eom.name, eom);

    }
}

export default AdminOrganizationEnterpriseObjectMetadata;